export const CATEGORY_SERVICE = [
  { id: 'SERVICIO', label: 'Pagos de servicio' },
  { id: 'PAQUETERIA', label: 'Paqueteria' },
  { id: 'RECARGA', label: 'Pago de recargas' }
];

export const SERVICES_DAG = {
  envios: 'ENVIO',
  recargas: 'RECARGA',
  servicios: 'SERVICIO',
  empaques: 'EMPAQUE',
  repartoMultimarca: 'REP_MULTIMARCA'
};
